import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AppLayout } from "./Components/AppLayout";
import { AppRoutes } from "./Components/AppRoutes";
import { ToastContainer } from "./Components/ToastNotification";
var App = function () {
    return (_jsxs(_Fragment, { children: [_jsx(ToastContainer, { closeButton: false, newestOnTop: true, pauseOnFocusLoss: true, pauseOnHover: true }), _jsx(AppLayout, { children: _jsx(AppRoutes, {}) })] }));
};
export default App;
